import React from 'react';
import Icon from '../../../components/AppIcon';

const PilgrimStatsCard = ({ icon, label, value, trend, trendValue, variant = 'default' }) => {
  const variantStyles = {
    default: 'bg-card border-border',
    success: 'bg-success/10 border-success/20',
    warning: 'bg-warning/10 border-warning/20',
    error: 'bg-error/10 border-error/20',
    primary: 'bg-primary/10 border-primary/20'
  };

  const iconColors = {
    default: 'text-primary',
    success: 'text-success',
    warning: 'text-warning',
    error: 'text-error',
    primary: 'text-primary'
  };

  return (
    <div className={`${variantStyles?.[variant]} border rounded-lg p-4 md:p-6 shadow-warm transition-smooth hover:shadow-warm-md`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${variant === 'default' ? 'bg-primary/10' : 'bg-background/50'} flex items-center justify-center`}>
          <Icon name={icon} size={20} className={iconColors?.[variant]} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 caption ${trend === 'up' ? 'text-success' : 'text-error'}`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{trendValue}</span>
          </div>
        )}
      </div>
      <div>
        <p className="caption text-muted-foreground mb-1">{label}</p>
        <p className="text-2xl md:text-3xl font-semibold text-foreground data-text">{value}</p>
      </div>
    </div>
  );
};

export default PilgrimStatsCard;